<template>
  <div>
    <!-- <div class="banner">
      <el-carousel arrow="always" height="460px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img
            :src="$config.imgUrl + item.imgPath"
            alt=""
            style="object-fit: cover; width: 100%; height: 100%"
          />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="home_page">
      <div style="background: #fff; margin: 20px 15% 10px 15%">
        <div class="home_title">
          <div class="title-bg">
            <div style="margin-top: -12px">公司动态</div>
            <div class="title-EN">COMPANY DYNAMICS</div>
          </div>
        </div>
        <div class="home_banner_main">
          <div class="banner_left">
            <el-carousel
              :interval="5000"
              arrow="always"
              height="384px"
              style="cursor: pointer"
            >
              <el-carousel-item v-for="(item, index) in newList" :key="index">
                <img
                  class="banner_img"
                  :src="$config.imgUrl + item.imgPath"
                  @click="goNewsDetails(item)"
                  alt=""
                />
                <div class="banner_title">
                  <div @click="goNewsDetails(item)">{{ item.title }}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="news_list">
            <div class="news_title">
              <div class="left">
                <div
                  :class="active == 1 ? 'titles' : 'btn'"
                  @click="(active = 1), getNewsData()"
                >
                  新闻动态
                </div>
                <div
                  :class="active == 2 ? 'titles' : 'btn'"
                  @click="(active = 2), loadList()"
                >
                  制度公告
                </div>
              </div>
              <div
                class="titles1"
                @click="
                  $router.push({
                    path: '/newsPage?active=' + active,
                  })
                "
              >
                More
              </div>
            </div>
            <div class="news_main" v-if="active == 1">
              <template v-for="(item, index) in newList.slice(0, 3)">
                <div class="news_item" :key="index">
                  <div class="item_left">
                    <img :src="$config.imgUrl + item.imgPath" alt="" />
                  </div>
                  <div class="item_right">
                    <div class="right_title" @click="goNewsDetails(item)">
                      {{ item.title }}
                    </div>
                    <div class="right_describe">{{ item.summary }}</div>
                    <div class="right_date">{{ item.createTime }}</div>
                  </div>
                </div>
              </template>
            </div>
            <div class="news_main" v-if="active == 2">
              <template v-if="loadLists">
                <div
                  v-for="(item, index) in loadLists.slice(0, 10)"
                  class="news_item"
                  :key="index"
                >
                  <div class="listitem">
                    <div
                      class="right_title"
                      @click="toPath(JSON.parse(item.attachmentPath)[0].url)"
                    >
                      {{ item.systemName }}
                    </div>
                    <div class="right_date">
                      {{ item.createTime.slice(0, 10) }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>暂无数据</template>
            </div>
          </div>
        </div>
        <div class="home_title">
          <div class="title-bg">
            <div style="margin-top: -12px">公司介绍</div>
            <div class="title-EN">COMPANY INTRODUCTION</div>
          </div>
        </div>
        <div class="company_introduce">
          <img
            :src="$config.imgUrl + companyInfo.imgArr"
            alt=""
            width="670"
            height="217"
            style="border-radius: 20px 0 20px 0; margin-left: 20px"
          />
          <div class="content">
            <p>
              {{ companyInfo.content }}
            </p>
          </div>
        </div>
      </div>
      <div class="product">
        <div class="home_title" style="margin-bottom: 0">
          <div class="title-bg other">
            <div style="margin-top: -12px">主要产品</div>
          </div>
        </div>
        <div class="product_main">
          <div class="product-img">
            <template v-for="(item, index) in productList">
              <div class="img-item" :key="index" @click="clickProduct(item)">
                <img
                  :src="$config.imgUrl + item.productImgPath"
                  alt=""
                  width="100%"
                  height="100%"
                  style="border-radius: 10px"
                />
                <div class="item_title">
                  <span> {{ item.productName }}</span>
                </div>
              </div>
            </template>
          </div>
          <div class="product-content">
            <p>{{ productContent }}</p>
          </div>
        </div>
      </div>
      <div class="home_title">
        <div class="title-bg">
          <div style="margin-top: -12px">合作洽谈</div>
          <div class="title-EN">cooperation</div>
        </div>
      </div>
      <div class="concat_main">
        <div class="map" id="container"></div>

        <div class="contacts">
          <div class="contacts-item">
            <div class="item-title">
              <div class="titles">联系人</div>
            </div>
            <div class="item-content">
              <div class="contents">
                <i class="el-icon-user-solid"></i>
                <span>{{ companyContact.contactName }}</span>
              </div>
              <div class="contents">
                <i class="el-icon-phone"></i>
                <span>{{ companyContact.contactPhone }}</span>
              </div>
              <div class="contents">
                <i class="el-icon-message"></i>
                <span>{{ companyContact.contactEmail }}</span>
              </div>
            </div>
          </div>
          <div class="contacts-item">
            <div class="item-title">
              <div class="titles">地 址</div>
            </div>
            <div class="item-contents">
              <div class="contents">
                <i class="el-icon-location-outline"></i>
                <span>公司地址：{{ companyContact.address }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
// 设置安全密钥
window._AMapSecurityConfig = {
  securityJsCode: "077b6f3c0bd5cfec9d91d6d53b128ad0",
};
export default {
  comments: {},
  data() {
    return {
      map: null,
      active: 1,
      url: {
        // banner
        banner: "/index/appletBanner",
        // 公司介绍
        introduce: "/index/companyIntroduce",
        // 新闻动态
        news: "/index/companyNews",
        // 主要产品
        product: "/index/companyProduct",
        // 合作洽谈
        address: "/index/companyContact",
        //制度公告
        list: "/employee/systemManage/list",
      },
      bannerList: [],
      newList: [],
      loadLists: [],
      companyInfo: {},
      productList: [],
      companyContact: {},
      productContent: "",
    };
  },
  mounted() {
    this.getBannerData();
    this.getIntroduceData();
    this.getNewsData();
    this.getProductData();
    this.getAddressData();
    this.GaodeMap();
  },
  methods: {
    GaodeMap() {
      AMapLoader.load({
        key: "d4af2b776c970168fb503700b25831b6", //key值是key值 和安全密钥不同
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          // 初始化地图
          this.map = new AMap.Map("container", {
            viewMode: "2D", //  是否为3D地图模式
            zoom: 13, // 初始化地图级别
            center: [105.430488, 37.561469], //中心点坐标
            resizeEnable: true,
          });
          var marker = new AMap.Marker({
            position: new AMap.LngLat(105.430488, 37.561469), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: "三元中泰",
          });
          this.map.add(marker);
        })
        .catch((e) => {});
    },
    product(i) {
      return {
        width: 100 / i + "%",
      };
    },
    loadList() {
      this.$http.getRequest(this.url.list, { indexShow: 1 }).then((res) => {
        if (res.data.code === 200) {
          this.loadLists = res.data.data;
        }
      });
    },
    // banner
    getBannerData() {
      this.$http.getRequest(this.url.banner, {}).then((res) => {
        if (res.data.code === 200) {
          this.bannerList = res.data.data;
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    // 公司介绍
    getIntroduceData() {
      this.$http.getRequest(this.url.introduce, {}).then((res) => {
        if (res.data.code === 200) {
          let describe = res.data.data.imgPath.split(",");
          this.companyInfo = res.data.data;
          if (describe.length > 0) {
            this.companyInfo.imgArr = describe[0];
          }
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    // 新闻动态
    getNewsData() {
      this.$http.getRequest(this.url.news, {}).then((res) => {
        if (res.data.code === 200) {
          this.newList = res.data.data;
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    // 主要产品
    getProductData() {
      this.$http.getRequest(this.url.product, {}).then((res) => {
        if (res.data.code === 200) {
          this.productList = res.data.data.slice(0, 4);
          if (this.productList.length > 0) {
            this.clickProduct(this.productList[0]);
          }
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    clickProduct(item) {
      this.productContent = item.productIntroduce;
    },
    // 合作洽谈
    getAddressData() {
      this.$http.getRequest(this.url.address, {}).then((res) => {
        if (res.data.code === 200) {
          this.companyContact = res.data.data;
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    //前往新闻详情
    goNewsDetails(data) {
      this.$router.push({
        name: "新闻详情",
        params: { data: JSON.stringify(data) },
      });
    },
    toPath(url) {
      if (url) {
        window.open(this.$config.imgUrl + url);
      }
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  height: 100%;
  margin-top: -41px;
}

.home_page {
  height: 100%;
  .concat_main {
    //width: 100%;
    //height: 320px;
    padding: 0 18%;

    .map {
      height: 320px;
      border: 1px solid #bababa;

      .title {
        font-size: 18px;
        font-family: "黑体";
        font-weight: bold;
      }

      .info {
        color: rgba(5, 17, 46, 0.58);
        font-size: 16px;
        font-family: "黑体";
      }
    }

    .contacts {
      width: 100%;
      height: 116px;
      //background-color: #00cd35;
      margin-top: 15px;
      display: flex;
      justify-content: space-between;

      .contacts-item {
        width: 48%;
        //height: 100px;
        background-color: #eeeeee;
        padding: 10px;

        .item-title {
          width: 100%;
          height: 37px;
          border-bottom: 2px solid #aa0000;

          .titles {
            width: 130px;
            height: 37px;
            background-color: #aa0000;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
        }

        .item-content {
          width: 100%;
          height: 58px;
          //background-color: black;
          display: flex;
          align-items: center;
          justify-content: space-around;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          margin-top: 5px;

          .contents {
            color: #aa0000;

            span {
              margin-left: 5px;
              color: #000000;
            }
          }
        }

        .item-contents {
          width: 100%;
          height: 58px;
          //background-color: black;
          display: flex;
          align-items: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          margin: 5px 0 0 10px;

          .contents {
            color: #aa0000;

            span {
              margin-left: 5px;
              color: #000000;
            }
          }
        }
      }
    }
  }
  .left {
    display: flex;
    cursor: pointer;
    .btn {
      width: 130px;
      height: 37px;
      border-top: 2px solid #aa0000; /* 上边框，黑色，2像素宽度 */
      border-right: 2px solid #aa0000; /* 右边框，黑色，2像素宽度 */
      border-left: 2px solid #aa0000; /* 左边框，黑色，2像素宽度 */
      border-bottom: none; /* 底边框，无 */
      display: flex;
      justify-content: center;
      align-items: center;
      color: #aa0000;
    }
  }

  .product {
    width: 100%;
    background-color: #d4d8db;
  }

  .product_main {
    //display: flex;
    padding: 0 18% 10px 18%;

    .product_item {
      text-align: center;

      .item_title {
        color: rgba(70, 68, 68, 1);
        font-size: 24px;
        text-align: center;
        font-family: SourceHanSansSC-medium;
      }

      .item_img {
        margin-top: 10px;

        img {
          // min-height: 200px;
          // max-height: 400px;
          height: 240px;
          width: 80%;
          border-radius: 10px;
        }
      }

      .item_info {
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: rgba(0, 0, 0, 0.5);
        font-size: 16px;
      }
    }

    .product-img {
      //background-color: #f0f9eb;
      width: 100%;
      //height: 50px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-around;

      .img-item {
        width: 360px;
        height: 240px;
        //background-color: #aa0000;
        border-radius: 10px;
        position: relative;

        .item_title {
          position: absolute;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          width: 100%;
          height: 51px;
          line-height: 51px;
          font-size: 22px;
          color: #ffffff;
          border-radius: 0 0 10px 10px;

          span {
            margin-left: 10px;
          }
        }
      }
    }

    .product-content {
      //width: 100%;
      //height: 100px;
      //background-color: #00cd35;
      margin-bottom: 15px;
      padding: 1px 10px;
      text-indent: 36px;
    }
  }

  .company_introduce {
    padding: 10px 1% 0 1%;
    display: flex;
    align-items: center;

    .content {
      width: 40%;
      padding: 0 0 0 6%;
      line-height: 44px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-indent: 36px;
    }

    .introduce_title {
      color: rgba(40, 38, 38, 1);
      font-size: 24px;
      text-align: center;
      line-height: 40px;
      font-family: SourceHanSansSC-regular;
    }

    .introduce_img {
      display: flex;
      padding: 20px 40px;

      .item {
        height: 200px;
        margin: 0 40px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }
  }

  .home_title {
    width: 100%;
    text-align: center;
    color: #000000;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 10px;
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    .title-bg {
      background: url("../../../assets/indexImg/gongsidongtai.png") no-repeat;
      background-size: 100% 100%;
      width: 983px;
      height: 9px;
      margin: 50px 0;

      .title-EN {
        font-size: 14px;
        font-family: Myriad Pro;
        font-weight: 400;
        color: #bababa;
        margin: 10px 0;
        letter-spacing: 2px;
      }
    }

    .other {
      background: url("../../../assets/indexImg/product.png") no-repeat;
    }
  }

  .home_banner_main {
    display: flex;
    padding: 0 1%;
    height: 400px;

    .banner_left {
      width: calc(60% - 40px);
      height: calc(500px - 40px);
      padding: 20px 20px 0 20px;
      position: relative;

      ::v-deep .el-carousel__indicators--horizontal {
        left: 72%;
        transform: translateX(0%);
        line-height: 45px;

        .el-carousel__button {
          height: 10px;
        }
      }

      ::v-deep .el-carousel__indicator.is-active button {
        background-color: #aa0000;
      }

      .banner_title {
        width: 100%;
        height: 45px;
        line-height: 45px;
        position: absolute;
        color: #ffffff;
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-bold;
        left: 0;
        bottom: 0;
        z-index: 3;
        background-color: rgba(0, 0, 0, 0.7);

        div {
          width: 70%;
          height: 100%;
          margin-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .banner_img {
        width: 100%;
        height: 339px;
        object-fit: cover;
      }
    }

    .news_list {
      width: calc(100% - 60% - 20px);
      height: calc(500px - 2px);
      margin-left: auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 10px;
      //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      .news_title {
        width: 95%;
        height: 37px;
        margin: 10px 10px 5px 10px;
        //padding: 5px 33px;
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        font-family: SourceHanSansSC-bold;
        border-bottom: 2px solid #aa0000;
        display: flex;
        justify-content: space-between;

        .titles {
          width: 130px;
          height: 37px;
          background-color: #aa0000;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .titles1 {
          line-height: 50px;
          display: flex;
          color: red;
          cursor: pointer;
        }
      }

      .news_page {
        margin-left: auto;
      }

      .news_main {
        padding-right: 20px;
        width: calc(100% - 40px);
        margin: 10px;
        height: 407px;
        overflow-y: scroll;

        .news_item {
          // border-bottom: 1px solid rgba(0, 0, 0, 0.3);
          display: flex;
          margin-bottom: 7px;

          .item_left {
            width: 180px;

            img {
              width: 180px;
              height: 103px;
              //border-radius: 5px;
            }
          }

          .item_right {
            width: calc(100% - 180px);
            margin-left: 10px;

            .right_describe {
              height: 35px;
              margin-top: 5px;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-family: SourceHanSansSC-medium;
              color: rgba(70, 68, 68, 0.7);
              font-size: 14px;
              line-height: 18px;
              overflow: hidden;
            }

            .right_date {
              margin-top: 5px;
              font-family: SourceHanSansSC-medium;
              color: rgba(70, 68, 68, 0.7);
              font-size: 14px;
              line-height: 20px;
            }
          }
          .right_title {
            width: 100%;
            margin-top: 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: SourceHanSansSC-medium;
            color: rgba(70, 68, 68, 1);
            font-size: 18px;
            font-weight: 600;
            cursor: pointer;
          }

          .right_title:hover {
            color: #0096ff;
            text-decoration: underline;
          }
          .listitem {
            width: 100%;
            display: flex;
            justify-content: space-between;
            cursor: pointer;

            .right_title {
              width: 75%;
              overflow: hidden;
              text-overflow: ellipsis;
              font-family: SourceHanSansSC-medium;
              color: rgba(70, 68, 68, 1);
              font-size: 18px;
              font-weight: 600;
              display: flex;
              align-items: baseline;
            }
            .right_title:hover {
              color: #0096ff;
              text-decoration: underline;
            }
            .right_date {
              margin-top: 5px;
              font-family: SourceHanSansSC-medium;
              color: rgba(70, 68, 68, 0.7);
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
